<template>
  <AntButton
    :class="{[customClass]: !!customClass, 'ant-btn--simple': simple }"
    :block="fullWidth"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot />
  </AntButton>
</template>

<script>
import { Button as AntButton } from 'ant-design-vue';

export default {
  name: 'Button',
  components: { AntButton },
  props: {
    customClass: {
      type: String,
      default: null,
    },
    fullWidth: {
      type: Boolean,
      default: false,
    },
    simple: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
  .ant-btn {
    /* TODO: add font */
    /* font-family: SFProText; */
    border-radius: 12px;
    border: 0;
    color: $primary;
    font-size: 14px;
    font-weight: 600;
    height: 50px;
    letter-spacing: .19px;

    &.ant-btn-submit {
      background: $accent;
      color: $white;

      &:hover {
        background-color: darken($accent, 10%);
        transition: all .6s;
      }
    }

    &--simple {
      border: none;
      background: none;
      height: auto;
      box-shadow: none;
      padding: 0;
      color: $accent;
    }
  }
</style>
